import { CONTAINER_NAME } from "../_utils/constant";
import { normalize } from "../common";
var vibrateLong = normalize(function (_ref) {
  var success = _ref.success,
      fail = _ref.fail,
      complete = _ref.complete;
  swan.vibrateLong({
    success: success,
    fail: fail,
    complete: complete
  });
}, CONTAINER_NAME.BAIDU);
export default vibrateLong;